import { render, staticRenderFns } from "./sub-item.vue?vue&type=template&id=3c1dd49c&"
import script from "./sub-item.vue?vue&type=script&lang=ts&"
export * from "./sub-item.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports